import React from 'react';
import { FaBuilding } from 'react-icons/fa';

const CompanyCard = ({ company, onSelect }) => {
  return (
    <div 
      className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer p-6 h-[220px] flex flex-col border border-gray-100 hover:border-amber-300 hover:scale-[1.02]"
      onClick={() => onSelect(company)}
    >
      <div className="flex items-center gap-3 mb-3">
        <div className="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center text-2xl flex-shrink-0">
          {company.logo}
        </div>
        <h3 className="text-lg font-bold text-gray-900 line-clamp-1">{company.name}</h3>
      </div>
      <p className="text-gray-600 text-sm flex-grow line-clamp-3 overflow-hidden">
        {company.description}
      </p>
      <div className="flex items-center justify-between mt-3 pt-3 border-t border-gray-100">
        <span className="text-amber-600 font-medium text-sm flex items-center gap-1">
          <FaBuilding className="text-xs" /> {company.projectsCount} projects
        </span>
        <span className="text-gray-400 text-sm">View →</span>
      </div>
    </div>
  );
};

export default CompanyCard;